export function getAccountingToken(state) {
    return state.accountingToken
}

export function getAccountingUrl(state) {
    return state.accountingUrl
}
export function getCompanies(state) {
    return state.companies
}

export function getSignature(state) {
    return state.signature
}

